import { TableRow } from '@crossnokaye/ux-common';

import { DetailsFormData } from '@/features/equipment-browser/equipment-details/details-form/equipment-details-form.types';

import { DefrostScheduleDateCell } from './defrost-schedule-date-cell';
import { DefrostScheduleEventDaysCell } from './defrost-schedule-event-days-cell';
import { DefrostScheduleTimeCell } from './defrost-schedule-time-cell';
import { DeleteEventCell } from './delete-event-cell';
import { DirtyEventCell } from './dirty-event-cell';

type DefrostScheduleRowProps = {
  index: number;
  initialEvent?: DetailsFormData['defrostSchedule'][number];
};

export const DefrostScheduleRow: React.FC<DefrostScheduleRowProps> = ({ index, initialEvent }) => {
  return (
    <TableRow>
      <DirtyEventCell index={index} initialEvent={initialEvent} />
      <DefrostScheduleEventDaysCell index={index} />
      <DefrostScheduleTimeCell index={index} />
      <DefrostScheduleDateCell index={index} />
      <DeleteEventCell index={index} />
    </TableRow>
  );
};
